module.exports = __webpack_public_path__ + "media/images/tip_input-cc1fa4e0918827d762d63b280bde1069.png";